<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @hidden="resetForm"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      no-enforce-focus>
        <form autocomplete="off" @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="modal-body">
            <div class="row container-fluid">

              <div class="form-group col-md-12">
                <label for="course"><b>Curso&nbsp;<span class="asterisk">*</span></b></label>
                <v-select v-model="form.coursename" :options="courses" class="my-custom-select" placeholder="Seleccione..."></v-select>
                <span v-if="courseValid" class="text-danger" style="font-size: 10px;"><b>El campo Curso es requerido.</b></span>
              </div>

              <div class="form-group col-md-12">
                <label for="course"><b>Estudiante&nbsp;<span class="asterisk">*</span></b>
                  <!-- Spinner for search student -->
                  <span v-if="loading===1">
                    <b-spinner style="margin-bottom: 3px;" small type="grow"></b-spinner>
                    <b-spinner style="margin-bottom: 3px;" small type="grow"></b-spinner>
                    <b-spinner style="margin-bottom: 3px;" small type="grow"></b-spinner>
                  </span>
                </label>
                <v-select v-model="form.studentname" :options="students" class="my-custom-select" searchable @search="fetchStudents" placeholder="Buscar..."></v-select>
                <cite style="font-size: 10px;">Ingrese al menos 3 caracteres (nombre, apellido o numero de documento)</cite><br>
                <span v-if="studentValid" class="text-danger" style="font-size: 10px;"><b>El campo Estudiante es requerido.</b></span>
              </div>

              <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </form>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/dist/vue-select.css';
import { BModal } from 'bootstrap-vue';
import { BSpinner } from 'bootstrap-vue';
import vSelect from 'vue-select';

export default {
  components: {BModal, vSelect, BSpinner},
  props: ['id', 'showModal'],
  data() {
    return {
      form: {
        coursename: '',
        studentname: '',
      },
      courses: [],
      students: [],
      studentValid: false,
      courseValid: false,
      timeValid: false,
      loading: 0,
      textMessage: 'Asignar Curso',
    }
  },
  mounted() {
      this.getCourses();
  },
  methods:{
    handleFileChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.video = event.target.files[0];
    },
    close(bvModalEvent) {
      this.resetForm();
      this.textMessage = 'Crear Curso'
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    cancel(bvModalEvent) {
      this.resetForm();
      this.textMessage = 'Crear Curso'
      this.$emit('update:showModal', false)
    },
    resetForm() {
      // Este método se ejecutará cuando el modal se oculte
      this.form = {
        coursename: '',
        studentname: '',
      };
      this.courseValid= false;
      this.timeValid= false;
      this.loading= 0;
    },
    getCourses() {
      axios.get(`/administration/assignCourses/getCourses`)
        .then(response => {
            this.courses = response.data.data
        })
    },
    // getStudents() {
    //   axios.get(`/administration/assignCourses/getStudents`)
    //     .then(response => {
    //         this.students = response.data.data
    //     })
    // },
    fetchStudents(searchString) {
      this.loading = 1;
      if (searchString.length <= 2) {
        this.students= [];
        this.loading = 0;
      }
      if (searchString.length >= 3) {
        axios.get(`/administration/assignCourses/getStudents?search=${searchString}`)
          .then(response => {
              this.students = response.data.data
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.loading = 0
          })
      }
    },
    // getRecord() {
    //   this.loading = true

    //   if(this.id) {
    //     axios.get(`/administration/courses/courses/${this.id}`)
    //     .then(response => {
    //       this.textMessage = 'Editar Curso'
    //         this.form = response.data
    //     })
    //     .finally(() => {
    //       this.loading = false
    //     })
    //   } else {
    //     this.form = {}
    //   }
    // },
    onlyNumber(e) {
      var key = window.Event ? e.which : e.keyCode;

      // Rango de códigos de tecla para números en el teclado principal y en el teclado numérico
      if (!((key >= 48 && key <= 57) ||  // Teclas numéricas en el teclado principal
            (key >= 96 && key <= 105))) { // Teclas numéricas en el teclado numérico
        e.preventDefault();
      }
    },
    submitForm() {
      this.courseValid = false;
      this.studentValid = false;

      // Validar campos
      if (this.form.coursename == '' || this.form.coursename == null) {
        this.courseValid = true;
      }

      if (this.form.studentname == '' || this.form.studentname == null) {
        this.studentValid = true;
      }

      // Si algún campo no es válido, detener el envío del formulario
      if (this.courseValid == true || this.studentValid == true) {
        return;
      }

      let formData = new FormData();

      formData.append('coursename_id', this.form.coursename.value);
      formData.append('studentname_id', this.form.studentname.value);

      axios.post('/administration/assignCourses', formData)
      .then(response => {
        if (response.data.status == 'error') {
          toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
        } else {
          toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
        }
        this.close();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
    },
  }
}

</script>

<style>
#__BVID__6___BV_modal_outer_ {
  /*z-index: 1000 !important;*/
  z-index: calc(var(--ck-z-panel) + 40) !important;
}
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
.bgHeader{
  background-color: #ccc;
}
</style>